var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"navbar",attrs:{"md":"9","lg":"3"}},[_c('div',{staticClass:"brand-logo navbar-brand"},[_c('b-img',{staticStyle:{"max-width":"50px"},attrs:{"alt":"logo","name":"logo","src":_vm.appLogoImage}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }